export default {
	NotificationUser: function (state) {
		return state.NotificationUser;
	},
	IsShowNotification: function (state) {
		return state.IsShowNotification;
	},
	NotificationInvoiceWaiting: function (state) {
		return state.NotificationInvoiceWaiting;
	},
	NotificationsInbot: function (state) {
		return state.NotificationsInbot;
	},
	NotificationProcessSyncData: function (state) {
		//Sort data theo SyncTime
		return state.NotificationProcessSyncData.sort(
			(a, b) => new Date(b.SyncTime).getTime() - new Date(a.SyncTime).getTime()
		);
	},
	GetNotificationProcessSyncData: function (state) {
		return state.NotificationProcessSyncData;
	},
	IsShowNotificationChangeStatusInvoice: function (state) {
		return state.IsShowNotificationChangeStatusInvoice;
	},
	IsShowNewFeature: function (state) {
		return state.IsShowNewFeature;
	},
	AssistantPanelData(state) {
		return state.AssistantPanelData
	},


	/**
	 * Lấy getRemindersByOrgId theo orgId
	 */
	getRemindersByOrgId: (state) => (orgId) => {
		const orgKey = String(orgId);
		if (!state.AssistantPanelData || !Array.isArray(state.AssistantPanelData)) {
			return {
				assistantReminders: [],
				horizontalReminders: [],
			};
		}
		const orgData = state.AssistantPanelData.find(x => x.orgId == orgKey);
		return orgData || {
			assistantReminders: [],
			horizontalReminders: [],
		};
	},

	/**
	 * Lấy horizontalReminders theo orgId
	 */
	getHorizontalRemindersByOrgId: (state) => (orgId) => {
		const orgKey = String(orgId);
		if (!state.AssistantPanelData || !Array.isArray(state.AssistantPanelData)) {
			return [];
		}
		const orgData = state.AssistantPanelData.find(x => x.orgId == orgKey);
		return orgData ? (orgData.horizontalReminders || []) : [];
	},

	/**
	 * Lấy assistantReminders theo orgId
	 */
	getAssistantRemindersByOrgId: (state) => (orgId) => {
		const orgKey = String(orgId);
		if (!state.AssistantPanelData || !Array.isArray(state.AssistantPanelData)) {
			return [];
		}
		const orgData = state.AssistantPanelData.find(x => x.orgId == orgKey);
		return orgData ? (orgData.assistantReminders || []) : [];
	},
};
